var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareAtm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -571.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/ATM",
    transform: "translate(3498.000000, 571.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,16 C26.656,16 28,17.343 28,19 L28,19 L28,29 C28,30.657 26.656,32 25,32 L25,32 L19,32 C17.343,32 16,30.657 16,29 L16,29 L16,19 C16,17.343 17.343,16 19,16 L19,16 Z M22,18 L19,18 L19,30 L22,30 L22,18 Z M32,0 L32,20 C32,22.025 31.241,23.87 30,25.279 L30,25.279 L30,19 C30,16.238 27.762,14 25,14 L25,14 L19,14 C16.239,14 14,16.238 14,19 L14,19 L14,28 L0,28 L0,6 C0,2.687 2.687,0 6,0 L6,0 L32,0 Z M12,21 C11.448,21 11,21.448 11,22 C11,22.552 11.448,23 12,23 C12.552,23 13,22.552 13,22 C13,21.448 12.552,21 12,21 Z M8,21 C7.448,21 7,21.448 7,22 C7,22.552 7.448,23 8,23 C8.552,23 9,22.552 9,22 C9,21.448 8.552,21 8,21 Z M4,21 C3.448,21 3,21.448 3,22 C3,22.552 3.448,23 4,23 C4.552,23 5,22.552 5,22 C5,21.448 4.552,21 4,21 Z M12,17 C11.448,17 11,17.448 11,18 C11,18.552 11.448,19 12,19 C12.552,19 13,18.552 13,18 C13,17.448 12.552,17 12,17 Z M8,17 C7.448,17 7,17.448 7,18 C7,18.552 7.448,19 8,19 C8.552,19 9,18.552 9,18 C9,17.448 8.552,17 8,17 Z M4,17 C3.448,17 3,17.448 3,18 C3,18.552 3.448,19 4,19 C4.552,19 5,18.552 5,18 C5,17.448 4.552,17 4,17 Z M12,13 C11.448,13 11,13.448 11,14 C11,14.552 11.448,15 12,15 C12.552,15 13,14.552 13,14 C13,13.448 12.552,13 12,13 Z M8,13 C7.448,13 7,13.448 7,14 C7,14.552 7.448,15 8,15 C8.552,15 9,14.552 9,14 C9,13.448 8.552,13 8,13 Z M4,13 C3.448,13 3,13.448 3,14 C3,14.552 3.448,15 4,15 C4.552,15 5,14.552 5,14 C5,13.448 4.552,13 4,13 Z M28,8 L16,8 L16,10 L28,10 L28,8 Z",
    id: 118
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareAtm);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-atm.afddca55.svg";
export { ForwardRef as ReactComponent };